import {Alert, Platform, View} from 'react-native';
import React, {useEffect, useRef, useState} from 'react';
import {apiUpdateUserBadges, getDailyChallenges} from 'src/Utils/apiCalls';
import {
  tryFacebookLogout,
  tryFirebaseLogout,
  tryGoogleLogout,
} from 'src/Utils/loginFunctions';

import {useSelector, useDispatch} from 'react-redux';

import {formatDailyChallenges} from 'src/Utils/dataFormatter';
import {logOutUser} from 'src/Redux/reducers/user_info.reducer';
import {saveUserInfo} from 'src/Redux/reducers/user_info.reducer';
import {setDailyChallenges} from 'src/Redux/reducers/dailyChallenges.reducer';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {
  logAttributesForSentryCrashlytics,
  updateDataAtPath,
  uploadMedia,
  useFirebaseData,
} from '../Utils/fireUtils';
import moment from 'moment';
import {captureScreen} from 'react-native-view-shot';

import {analytics} from 'src/Utils/db';

import {setDataAtPath} from 'src/Utils/fireUtils';
import {updateBadgesData} from '../Redux/reducers/badges.reducer';
import {mmkvStorage} from '../Utils/mmkvStorage';

import {getReduxState} from '../Utils/helpers';
const {isDetoxSync} =
  Platform.OS !== 'web'
    ? require('react-native-is-detox')
    : {
        isDetoxSync: () => false,
      };

const UserController = () => {
  isDetoxSync();
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.user?.userId);

  useEffect(() => {
    logAttributesForSentryCrashlytics('userId', `${userId || ''}`);
  }, [userId]);

  if (Platform.OS == 'web') {
    if (window?.location?.href?.includes?.('isDemo')) {
      const urlParams = new URLSearchParams(window?.location?.search);
      let urlUserId = urlParams?.get('userId');
      if (urlUserId) {
        useFirebaseData(`users/${urlUserId || 'error'}`, (userInfoData) => {
          console.log('UserController user data', {userInfoData});
          dispatch(saveUserInfo(userInfoData));
        });
      }
    }
  }

  const playTestState = useSelector((state) => state.app_info?.playTestState);

  const isAppLoading = useSelector((state) => {
    const currentScreen = state.current_screen?.currentScreen;
    return ['AppLoadingPage', 'AppIntroSwiper'].includes(currentScreen);
  });

  const logout = () => {
    try {
      tryFirebaseLogout();
      dispatch(logOutUser());
      tryGoogleLogout()
        .then(() => {
          console.log('GOOGLE LOGGED OUT');
          return mmkvStorage.delete('userId');
        })
        .then(() => {
          console.log('FACEBOOK LOGGED OUT');
          return tryFacebookLogout();
        })
        .then(() => {
          console.log('done');
        })
        .catch((error) => {
          console.log('Logout error: ', error);
        });
    } catch (err) {
      console.log(err);
    }
  };

  useFirebaseData(
    `users/${userId || 'error'}`,
    (userInfoData) => {
      if (!userId || !userInfoData || !userInfoData?.userId) {
        return console.log('no user data');
      }
      console.log(
        '<<<<<<<<<<<<<<<<<<<<<<<< update user >>>>>>>>>>>>>>>>>>>>>>>>>',
      );
      if (!userInfoData?.userId) {
        logout();
        Alert.alert(
          'Your have been signed out',
          'If you believe this happened in error, please contact support.',
        );
      }
      if (userInfoData?.firstName) {
        logAttributesForSentryCrashlytics(
          'firstName',
          `${userInfoData?.firstName || ''}`,
        );

        dispatch(saveUserInfo(userInfoData));
        mmkvStorage.set('userId', userId);
        mmkvStorage.set('userInfo', JSON.stringify(userInfoData));
      }

      if (
        Platform.OS == 'web' ||
        isDetoxSync() ||
        __DEV__ ||
        playTestState !== false
      ) {
        return console.log(`Don't show badge earn modal on dev and playtest`);
      }

      if (userInfoData?.badgesNewlyEarned && playTestState == false) {
        try {
          const newBadges = Object.values(userInfoData?.badgesNewlyEarned);
          if (newBadges && newBadges[0]) {
            const newBadge = newBadges[0];

            if (Platform.OS != 'web') {
              navigationRef.navigate('BadgeAwardModal', {
                badge: {...newBadge, isNew: true},
              });
            }

            setDataAtPath(
              `users/${userId || 'fdfsdfsdfsdf'}/badgesNewlyEarned/${
                newBadge?.id || 0
              }`,
              null,
            );
            const badgeLabel = `${newBadge?.requirement_type}-${newBadge?.requirement_quantity}`;
            analytics().logUnlockAchievement({
              achievement_id: badgeLabel,
            });
          }
        } catch (error) {
          Alert.alert('error', error.message);
        }
      }
    },
    null, // no order by
    null, // no order by
    false, // hide logs
    !userId, // suppress if pt or no userId);
  );

  useFirebaseData(
    `badges/${userId}`,
    (badgeData) => {
      console.log('badgeData updated');
      dispatch(updateBadgesData(badgeData));
    },
    null, // no order by
    null, // no order by
    false, // hide logs
    !userId || playTestState, // suppress if pt or no userId);
  );
  ///////////// query here for daily challenges ???????
  ///////////// full join on cities????????

  useEffect(() => {
    if (userId) {
      apiUpdateUserBadges();
    }
  }, [userId]);

  // forces re-query of user daily challenges info
  const resetDailyChallenges = async () => {
    const dailyChallenges = await getDailyChallenges(userId);

    dailyChallenges &&
      dispatch(setDailyChallenges(formatDailyChallenges(dailyChallenges)));
  };

  useEffect(() => {
    resetDailyChallenges?.();
  }, [userId]);

  return (
    <View>
      {!!userId && !!isAppLoading && (
        <UserEventUpdater key={`UserEventUpdater-${userId}`} userId={userId} />
      )}
    </View>
  );
};

const roundToSecond = (startString, roundTo = 1) => {
  if (!startString) {
    return 0;
  }
  const roundedString =
    Math.round(moment(startString).seconds() / roundTo) * roundTo;
  return roundedString;
};

const UserEventUpdater = ({userId}) => {
  const [requestTime, setRequestTime] = useState();

  useFirebaseData(
    `userScreenShot/${userId}/requestTime`,
    (newRequestTime) => {
      console.log({newRequestTime});
      setRequestTime(roundToSecond(newRequestTime, 5));
    },
    null,
    null,
    1,
  );

  const screenShotRequestTime = requestTime;
  const isMounted = useRef(false);

  const handleCaptureScreen = async () => {
    console.log('Event DataUpdater', {screenShotRequestTime});

    const appStateVisible = getReduxState([
      'current_screen',
      'appStateVisible',
    ]);

    if (appStateVisible != 'active') {
      return console.log('app is not visible dont take screen shot', {
        appStateVisible,
      });
    }

    const screenCaptureURI = await captureScreen({
      format: 'jpg',
      quality: 0.1,
    });
    const path = `userScreenShot/${userId || 'error'}/screenShot`;
    const userScreenCapture = await uploadMedia(
      path,
      screenCaptureURI,
      0,
      0,
      1,
    );

    // console.log({userScreenCapture});

    updateDataAtPath(path, {
      userScreenCapture,
      lastActive: moment().format('YYYY-MM-DDTHH:mm:ss.sssZ'),
    });
  };
  useEffect(() => {
    if (Platform.OS == 'web') {
      return; // web
    }
    if (isMounted.current && screenShotRequestTime) {
      console.log('new screen shot requested', {screenShotRequestTime});
      handleCaptureScreen(screenShotRequestTime);
    } else {
      isMounted.current = true;
    }
  }, [screenShotRequestTime]);

  return <View style={{}}></View>;
};

export default UserController;
